export default __webpack_public_path__ + "static/media/multiplier-low.60cbbca7.wav";